// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2084 ? "9b0008ae" : chunkId) + "." + {"761":"7e942f2aa225cd06","1701":"d2f3440f99b7ea2b","2084":"f5f757f83598bbe1","8892":"2848c6f7437b2b58"}[chunkId] + ".js";
};